<template>
  <BasicTile align="center" class="commission-tile__container d-flex flex-column justify-center w-100 px-4 py-8 pa-md-14 pa-sm-14 background-tile-big align-center ga-6 rounded-16">

		<span
			class="commission__amount-container rounded-lg px-6 py-5 d-flex flex-row justify-center align-center">
			
			
			<div class="commission__decorator-top rounded-xl pa-2">
				<v-icon>
					<crown></crown>
				</v-icon>
			</div>


			<v-icon class="commission__coin mr-2">
				<coin-big></coin-big>
			</v-icon>


			<span class="commission__amount no-wrap">250 Coins</span>

			<div class="commission__decorator-bottom d-flex justify-center align-center">
				<span class="triangle-top-left"></span>
				<span class="triangle-top-right"></span>
				<div class="commission__decorator-bottom__text">
					The more you refer, the more you earn
				</div>
				<span class="triangle-bottom-left"></span>
				<span class="triangle-bottom-right"></span>
			</div>



		</span>
		<div class="commission__description">+5% commission just for you!</div>

	</BasicTile>
</template>



<script setup>

import BasicTile from '@/components/Tiles/Basic-Tile.vue';
import Crown from '@/icons/Crown.vue';
import CoinBig from '@/icons/CoinBig.vue';

</script>



<style scoped lang="scss">
// TODO: Dont remove this code right now, it is used for the coin icon size, if we remove this code, the coin icon will be very small for the reason that only god knows
.commission__coin {}
</style>